import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  Lightning,
  MagnifyingGlass,
  Globe,
  Users,
  ChartBar,
  Export,
  Rocket,
  AddressBook,
  SignOut,
  Translate,
} from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";

const navItems = [
  { to: "/dashboard", icon: ChartBar, label: "Dashboard" },
  { to: "/dashboard/scanner", icon: MagnifyingGlass, label: "Lead Scanner" },
  { to: "/dashboard/niche-search", icon: AddressBook, label: "Niche Search" },
  { to: "/dashboard/generator", icon: Lightning, label: "Site Generator" },
  { to: "/dashboard/leads", icon: Users, label: "Lead Manager" },
  { to: "/dashboard/websites", icon: Globe, label: "Website Gallery" },
  { to: "/dashboard/launch", icon: Rocket, label: "Launch Kit" },
  { to: "/dashboard/translator", icon: Translate, label: "Translator" },
];

export default function Sidebar() {
  const location = useLocation();
  const { logout, user } = useAuth();

  return (
    <aside
      data-testid="sidebar"
      className="w-[220px] min-h-screen border-r border-border bg-white flex flex-col"
    >
      <div className="p-4 border-b border-border flex items-center gap-2">
        <Lightning weight="bold" size={22} className="text-[#002FA7]" />
        <span
          className="text-lg font-bold tracking-tight"
          style={{ fontFamily: "Cabinet Grotesk, sans-serif" }}
        >
          BlitzWeb
        </span>
      </div>

      <nav className="flex-1 py-3 flex flex-col gap-0.5">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/dashboard"}
            data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) =>
              `sidebar-link ${isActive ? "active" : ""}`
            }
          >
            <item.icon
              weight={location.pathname === item.to ? "bold" : "regular"}
              size={18}
            />
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-border space-y-2">
        <a
          href="/leads?export=csv"
          data-testid="export-csv-link"
          className="sidebar-link text-xs justify-center border border-border hover:border-[#002FA7] hover:text-[#002FA7]"
        >
          <Export weight="bold" size={14} />
          Export CSV
        </a>
        <button
          data-testid="logout-btn"
          onClick={logout}
          className="sidebar-link text-xs justify-center border border-border hover:border-[#FF2A00] hover:text-[#FF2A00] w-full"
        >
          <SignOut weight="bold" size={14} />
          Sign Out
        </button>
        {user?.email && (
          <p className="text-[10px] text-[#A1A1AA] text-center truncate">{user.email}</p>
        )}
      </div>
    </aside>
  );
}
